import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import { useEffect } from "react";
import { LoadingPage } from "../../components/LoadingPage";
import { useAppConfig } from "../../utilities/useAppConfig";
import { useParams } from "react-router-dom";

export function CheckoutPage() {
    const [config,] = useAppConfig();
    const { sessionId } = useParams<{sessionId: string}>();
	useEffect(() => {
		async function getSession(sessionId: string) {
				const stripe = await loadStripe(config.stripeApiKey);
				await stripe!.redirectToCheckout({ sessionId });
			}

		if(sessionId)
			getSession(sessionId);
	}, [sessionId]);

	return <LoadingPage />;
}